import type {
    MembershipIncome,
    MembershipIncomeUpsertDto,
} from '@fruitful/member-profile';

import type { MembershipDetails } from '../../entities/entityTypes';
import { useRefetchMembershipDetailsMutationOptions } from '../../entities/membership/hooks/useRefetchMembershipDetailsMutationOptions';
import { requestBuilder } from '../../http/RequestBuilder';

const useUpsertMembershipIncome = requestBuilder.mutation<
    MembershipIncome[],
    MembershipIncomeUpsertDto[],
    { membershipId: string }
>({
    endpoint: ({ membershipId }) =>
        `/api/admin/membership-income/${membershipId}`,
    method: 'POST',
});

export const useUpsertMembershipIncomeAndRefetch = (
    membership: MembershipDetails | null,
) => {
    const refetchMembershipMutationOptions =
        useRefetchMembershipDetailsMutationOptions(membership);

    const { mutateAsync } = useUpsertMembershipIncome(
        refetchMembershipMutationOptions,
    );

    const upsertMembershipIncomeAsync = async (
        membershipId: string,
        body: MembershipIncomeUpsertDto[],
    ) => {
        return await mutateAsync({
            urlParams: {
                membershipId,
            },
            body,
        });
    };

    return {
        upsertMembershipIncomeAsync,
    };
};
